webpackJsonp([114276838955818,60335399758886],{

/***/ 123:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Alyson Paige","description":"Web Developer, Digital Strategist, and Open Source Advocate"}}},"layoutContext":{}}

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(262);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(123);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(58);
	var isArguments = __webpack_require__(57);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(69);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(56);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(68);
	
	var _HelmetConstants = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(59));
	var shallowEqual = _interopDefault(__webpack_require__(71));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement('footer', { id: 'footer', style: props.timeout ? { display: 'none' } : {} });
	};
	
	Footer.propTypes = {
	    timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', style: props.timeout ? { display: 'none' } : {} },
	        _react2.default.createElement(
	            'div',
	            { className: 'logo' },
	            _react2.default.createElement('span', { className: 'icon fa-code' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'inner' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Alyson Paige'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Eat | Sleep | Code | Repeat'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Web Developer, Digital Strategist, and Open Source Advocate'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('intro');
	                            } },
	                        'Intro'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('work');
	                            } },
	                        'Work'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('about');
	                            } },
	                        'About'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('contact');
	                            } },
	                        'Contact'
	                    )
	                )
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onOpenArticle: _react2.default.PropTypes.func,
	    timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(118);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pic = __webpack_require__(186);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(480);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(481);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Main.prototype.render = function render() {
	    var _this2 = this;
	
	    var close = _react2.default.createElement('div', { className: 'close', onClick: function onClick() {
	        _this2.props.onCloseArticle();
	      } });
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'main', style: this.props.timeout ? { display: 'flex' } : { display: 'none' } },
	      _react2.default.createElement(
	        'article',
	        { id: 'intro', className: (this.props.article === 'intro' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Intro'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          "I'm highly organized, hard working, and an extremely responsible professional with a demonstrated ability to commit to projects. I have enthusiasm and passion for my work with a strength in analyzing issues and resolving challenging problems. I strive to create trust and build lasting relationships, both personally and professionally. I also have strong leadership capabilities as well as communication skills in both English & Spanish, allowing for successful interaction with people of diverse backgrounds, cultures and professional levels."
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Core Languages & Skills:'
	          ),
	          _react2.default.createElement('br', null),
	          'HTML5, CSS3, Javascript, Ruby',
	          _react2.default.createElement('br', null),
	          'Git, Github, Algorithms, APIs, Mobile & Responsive Design'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Libraries, Tools & Software:'
	          ),
	          _react2.default.createElement('br', null),
	          'jQuery, Bootstrap, Foundation, Ruby on Rails, WordPress, React.js',
	          _react2.default.createElement('br', null),
	          'Heroku, Netlify, Slack, Trello',
	          _react2.default.createElement('br', null),
	          'Microsoft Office, Photoshop, Illustrator'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Marketing:'
	          ),
	          _react2.default.createElement('br', null),
	          'SEO, Google Analytics, Social Media'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'ul',
	          { className: 'icons' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/alysonstiffel/', className: 'icon fa-linkedin' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'LinkedIn'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/alysonpaige', className: 'icon fa-github' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'GitHub'
	              )
	            )
	          )
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { id: 'work', className: (this.props.article === 'work' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Work'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic4.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          "Over the years, I've had the pleasure of working on many great projects with wonderful people and companies."
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          "Projects:"
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            "Budgety: "
	          ),
	          ' ',
	          "A beautifully simple budget app using JavaScript, HTML, and CSS."
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            "To Do List: "
	          ),
	          ' ',
	          "A dynamic, database-driven web app that fetches data using RESTful JSON APIs from Rails and uses JavaScript to dynamically update the page."
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            "Grammable: "
	          ),
	          ' ',
	          "An Instagram clone built using automated software tests (TDD) in Ruby with RSpec."
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            "Flixter: "
	          ),
	          ' ',
	          "A two sided video streaming marketplace platform, featuring credit card payment capabilities, user role management, complex user interfaces and advanced database relationships."
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            "Nomster: "
	          ),
	          ' ',
	          "A Yelp clone that integrates with Google Maps API and includes features like user comments, star ratings, image uploading, and user authentication."
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            "Splurty: "
	          ),
	          ' ',
	          "A database-powered quote generator with mobile-first design, using the Ruby on Rails framework, HTML and CSS."
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          "Open Source Contributions:"
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'em',
	            null,
	            "Coming Soon"
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'ul',
	          { className: 'icons' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/alysonstiffel/', className: 'icon fa-linkedin' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'LinkedIn'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/alysonpaige', className: 'icon fa-github' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'GitHub'
	              )
	            )
	          )
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { id: 'about', className: (this.props.article === 'about' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'About'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic6.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          "I'm Alyson Paige, a full stack web developer based in DC. I've always had a soft spot for technology. A few years ago, I saw an opportunity for personal growth and to enhance my knowledge in an industry that I love but which is rapidly changing and growing. I enjoy learning from the community and sharing what I know through meetups, discussion boards and volunteering."
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          "When I'm not buried in code, I love spending time with my husband and doing the following:"
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Reading'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Travelling'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Soccer'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Listening to podcasts and audiobooks'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Cycling & hiking'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            "Sleeping (highly recommend this activity)"
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Watching Netflix and soccer'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Did I mention soccer? I love soccer.'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'ul',
	          { className: 'icons' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/alysonstiffel/', className: 'icon fa-linkedin' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'LinkedIn'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/alysonpaige', className: 'icon fa-github' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'GitHub'
	              )
	            )
	          )
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { id: 'contact', className: (this.props.article === 'contact' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Contact'
	        ),
	        _react2.default.createElement(
	          'form',
	          { method: 'post', action: '#', 'data-netlify': 'true', 'data-netlify-honeypot': 'bot-field' },
	          _react2.default.createElement(
	            'div',
	            { className: 'field half first' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'name' },
	              'Name'
	            ),
	            _react2.default.createElement('input', { type: 'text', name: 'name', id: 'name', required: true })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field half' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email' },
	              'Email'
	            ),
	            _react2.default.createElement('input', { type: 'email', name: 'email', id: 'email', required: true })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'message' },
	              'Message'
	            ),
	            _react2.default.createElement('textarea', { name: 'message', id: 'message', rows: '4', placeholder: 'Share a joke or just get in touch and say hello...', required: true })
	          ),
	          _react2.default.createElement('div', { 'data-netlify-recaptcha': true }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'actions' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('input', { type: 'submit', value: 'Send Message', className: 'special' })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('input', { type: 'reset', value: 'Reset' })
	            )
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'ul',
	          { className: 'icons' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/alysonstiffel/', className: 'icon fa-linkedin' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'LinkedIn'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/alysonpaige', className: 'icon fa-github' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'GitHub'
	              )
	            )
	          )
	        ),
	        close
	      )
	    );
	  };
	
	  return Main;
	}(_react2.default.Component);
	
	Main.propTypes = {
	  route: _react2.default.PropTypes.object,
	  article: _react2.default.PropTypes.string,
	  articleTimeout: _react2.default.PropTypes.bool,
	  onCloseArticle: _react2.default.PropTypes.func,
	  timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.53bd1d14.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic03.731832c3.jpg";

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(380);
	
	var _reactHelmet = __webpack_require__(67);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(260);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(261);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Footer = __webpack_require__(259);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isArticleVisible: false,
	      timeout: false,
	      articleTimeout: false,
	      article: '',
	      loading: 'is-loading'
	    };
	    _this.handleOpenArticle = _this.handleOpenArticle.bind(_this);
	    _this.handleCloseArticle = _this.handleCloseArticle.bind(_this);
	    return _this;
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.timeoutId = setTimeout(function () {
	      _this2.setState({ loading: '' });
	    }, 100);
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeoutId) {
	      clearTimeout(this.timeoutId);
	    }
	  };
	
	  Template.prototype.handleOpenArticle = function handleOpenArticle(article) {
	    var _this3 = this;
	
	    this.setState({
	      isArticleVisible: !this.state.isArticleVisible,
	      article: article
	    });
	
	    setTimeout(function () {
	      _this3.setState({
	        timeout: !_this3.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this3.setState({
	        articleTimeout: !_this3.state.articleTimeout
	      });
	    }, 350);
	  };
	
	  Template.prototype.handleCloseArticle = function handleCloseArticle() {
	    var _this4 = this;
	
	    this.setState({
	      articleTimeout: !this.state.articleTimeout
	    });
	
	    setTimeout(function () {
	      _this4.setState({
	        timeout: !_this4.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this4.setState({
	        isArticleVisible: !_this4.state.isArticleVisible,
	        article: ''
	      });
	    }, 350);
	  };
	
	  Template.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    var siteDescription = this.props.data.site.siteMetadata.description;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'body ' + this.state.loading + ' ' + (this.state.isArticleVisible ? 'is-article-visible' : '') },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          siteTitle
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(_Header2.default, { onOpenArticle: this.handleOpenArticle, timeout: this.state.timeout }),
	        _react2.default.createElement(_Main2.default, {
	          isArticleVisible: this.state.isArticleVisible,
	          timeout: this.state.timeout,
	          articleTimeout: this.state.articleTimeout,
	          article: this.state.article,
	          onCloseArticle: this.handleCloseArticle
	        }),
	        _react2.default.createElement(_Footer2.default, { timeout: this.state.timeout })
	      ),
	      _react2.default.createElement('div', { id: 'bg' })
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-49b3a4fa9a6e5f4c23d7.js